"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState, useTransition } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import Loader from "../../Loader"
import { useReactiveVar } from "@apollo/client/react"
import { signUpEmailVar } from "../../../../graphql/reactiveVars"
import getAllUrlParams from "../../../../lib/url/getAllUrlParams"
import CreateAccount from "./CreateAccount"
import CreateBasicUserInfo from "./CreateBasicUserInfo"
import SignUpLoginHeader from "../../../pages/loginAndSignUp/shared/SignUpLoginHeader"
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace"
import IconButton from "@mui/material/IconButton"
import SendMailIcon from "../../../common/icons/SendMailIcon"
const VIEW_CREATE_ACCOUNT = "VIEW_CREATE_ACCOUNT"
const VIEW_BASIC_USER_INFO = "VIEW_BASIC_USER_INFO"

export default function SignUp() {
  const searchParams = useSearchParams()
  const allUrlParms = getAllUrlParams(searchParams)
  const cohortIdParam = searchParams.get("cohort_id")
  const sendMessage = searchParams.get("send_message")

  // console.log("SignUpContent allUrlParms", allUrlParms)
  const redirectToLeader = searchParams.get("redirect_to_leader")
  const newsletter = searchParams.get("newsletter")
  const signUpEmail = useReactiveVar(signUpEmailVar)
  const router = useRouter()
  const [isPending, startTransition] = useTransition()
  const [email, setEmail] = useState(signUpEmail || "")
  const [password, setPassword] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [notificationsChecked, setNotificationsChecked] = useState(true)
  const [policiesChecked, setPoliciesChecked] = useState(false)
  const [view, setView] = useState(VIEW_CREATE_ACCOUNT)

  const onCreateAccountContinue = () => {
    setView(VIEW_BASIC_USER_INFO)
  }

  const onViewCreateAccount = () => {
    setView(VIEW_CREATE_ACCOUNT)
  }
  const onCreateAccountSuccess = () => {
    router.push(
      allUrlParms ? `/signup/confirm-email?${allUrlParms}` : "/signup/confirm-email",
    )
  }
  // New function to build the login URL with appropriate query params
  const buildLoginUrl = () => {
    let loginUrl = allUrlParms ? `/login?${allUrlParms}` : "/login"
    const params = []

    if (redirectToLeader) {
      params.push("redirect_to_leader=true")
    }

    if (newsletter) {
      params.push("newsletter=true")
    }

    if (params.length) {
      loginUrl += allUrlParms ? params.join("&") : "?" + params.join("&")
    }
    return loginUrl
  }

  const renderCreateAccountBasicInfo = () => {
    return (
      <CreateBasicUserInfo
        onSignUpPage={true}
        visible={view == VIEW_BASIC_USER_INFO}
        email={email}
        password={password}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        notificationsChecked={notificationsChecked}
        setNotificationsChecked={setNotificationsChecked}
        policiesChecked={policiesChecked}
        setPoliciesChecked={setPoliciesChecked}
        onViewCreateAccount={onViewCreateAccount}
        onSuccess={onCreateAccountSuccess}
        redirectToLeader={redirectToLeader}
        cohortIdParam={cohortIdParam}
        key={"account-basic-info"}
        startTransition={startTransition}
      />
    )
  }
  const renderCreateAccountEmailAndPassword = () => {
    return (
      <CreateAccount
        onSignUpPage={true}
        setEmail={setEmail}
        setPassword={setPassword}
        email={email}
        password={password}
        visible={view == VIEW_CREATE_ACCOUNT}
        onCreateAccountContinue={onCreateAccountContinue}
        onLoginHref={buildLoginUrl()}
        key={"account-email-pw-info"}
      />
    )
  }

  const getHeadingText = () => {
    switch (view) {
      case VIEW_BASIC_USER_INFO:
        return "Finish Signing Up"
      case VIEW_CREATE_ACCOUNT:
      default:
        return "Sign up to Zest Life"
    }
  }

  const renderDescription = () => {
    if (!sendMessage) return null

    return (
      <div
        className="text-center mb-6 max-w-[389px] text-left"
        key="message-description"
      >
        <div className="flex flex-row items-center justify-between mb-3 leading-[1.2]">
          <p className="text-[21px] min-[600px]:text-[22px] max-w-[265px]">
            Create an account to send a secure message
          </p>
          <SendMailIcon />
        </div>
        <p className="text-[16px] min-[600px]:text-[18px] text-gray-600  leading-[1.2]">
          This is not instant messaging or crisis support. For immediate help, call
          988 or contact local emergency services.
        </p>
      </div>
    )
  }

  return [
    view === VIEW_CREATE_ACCOUNT ? (
      <div
        className={
          "flex flex-col items-center justify-center w-full max-w-[500px] text-black mb-[20px]"
        }
        key={"sign-up-header"}
      >
        <div className={``}>
          {/* <SignUpLoginHeader text={getHeadingText()} /> */}
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-6">
            <div className="max-w-4xl mx-auto">
              {/* Header */}
              <div className="text-center mb-8">
                <h1 className="text-4xl font-bold text-gray-800 mb-4">
                  Join the ZestLife Professional Network
                </h1>
                <p className="text-xl text-gray-600 mb-8">
                  Create an account to list your health and wellness groups and
                  connect with licensed providers
                </p>
              </div>

              {/* Benefits Overview */}
              <div className="max-w-2xl mx-auto">
                <div className="bg-white rounded-xl shadow-lg p-6">
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                        📋
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-800">
                          List Your Groups
                        </h4>
                        <p className="text-sm text-gray-600">
                          Share about your group and receive referrals
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        👥
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-800">
                          Professional Network
                        </h4>
                        <p className="text-sm text-gray-600">
                          Message colleagues and stay connected
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                        📧
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-800">
                          Community Updates
                        </h4>
                        <p className="text-sm text-gray-600">
                          Curated digest of new in-person + virtual group offerings
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                        🔍
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-800">
                          Discover Groups
                        </h4>
                        <p className="text-sm text-gray-600">
                          Find and refer groups for those you care for
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* <div className="mt-6 p-3 bg-gray-50 rounded-lg">
                    <p className="text-sm text-gray-600 text-center">
                      Trusted by <strong>2,500+</strong> mental wellness
                      professionals
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div
        className={"relative flex justify-center items-center w-full"}
        key={"sign-up-header"}
      >
        <div className={"absolute left-0"}>
          <IconButton
            onClick={() => {
              onViewCreateAccount()
            }}
          >
            <KeyboardBackspaceIcon fontSize={"large"} />
          </IconButton>
        </div>

        <SignUpLoginHeader text={getHeadingText()} />
      </div>
    ),
    sendMessage ? renderDescription() : null,
    renderCreateAccountEmailAndPassword(),
    renderCreateAccountBasicInfo(),
    isPending ? <Loader handleOnClick={() => {}} key={"loader-signup"} /> : null,
  ]
}
